export default __webpack_public_path__ + "static/media/000_intro_part2.hevc.8bf7331c.mp4";